import EditIcon from "@material-ui/icons/Edit";
import PowerOffIcon from '@mui/icons-material/PowerOff';
import PowerIcon from '@mui/icons-material/Power';
import RegularButton from "components/CustomButtons/Button";
import React from "react";
import { ColumnContainer } from "utils/columnsStyle";
import { useDispatch } from "react-redux";
import { APARTMENTS_CONFIG, APARTMENTS_PHRASE } from "./config";
import {
  editApartment,
  assignMeter,
  assignCustomer,
  assignContract,
} from "redux/actions/buildings/apartments/apartmentsActions";
import { GasMeter } from "@mui/icons-material";
import { AccountCircle, Assignment } from "@material-ui/icons";
import { PERMISSIONS } from "router/permissions";

const style = {
  color: "#004F9F",
  fontSize: 20,
  marginRight: 10,
  cursor: "pointer"
};

export const columns = [
  {
    Header: () => <span>{APARTMENTS_CONFIG.facility.label}</span>,
    accessor: APARTMENTS_CONFIG.facility.key,
    filterable: true,
    filterMethod: (filter, row) =>
      row[APARTMENTS_CONFIG.facility.key]
        ? row[APARTMENTS_CONFIG.facility.key]
          .toLowerCase()
          .includes(filter.value.toLowerCase())
        : ""
  },
  {
    Header: () => <span>{APARTMENTS_CONFIG.customer.label}</span>,
    accessor: APARTMENTS_CONFIG.customer.key,
    filterable: true,
    filterMethod: (filter, row) =>
      row[APARTMENTS_CONFIG.customer.key]
        ? row[APARTMENTS_CONFIG.customer.key]
          .toLowerCase()
          .includes(filter.value.toLowerCase())
        : ""
  },
  {
    Header: () => <span>{APARTMENTS_CONFIG.contract.label}</span>,
    accessor: APARTMENTS_CONFIG.contract.key,
    filterable: true,
    filterMethod: (filter, row) =>
      row[APARTMENTS_CONFIG.contract.key]
        ? row[APARTMENTS_CONFIG.contract.key]
          .toLowerCase()
          .includes(filter.value.toLowerCase())
        : ""
  },
  {
    Header: () => <span>{APARTMENTS_CONFIG.apartmentNumber.label}</span>,
    accessor: APARTMENTS_CONFIG.apartmentNumber.key,
    filterable: true,
    filterMethod: (filter, row) =>
      row[APARTMENTS_CONFIG.apartmentNumber.key]
        ? row[APARTMENTS_CONFIG.apartmentNumber.key]
          .toLowerCase()
          .includes(filter.value.toLowerCase())
        : ""
  },
  {
    Header: () => <span>{APARTMENTS_CONFIG.buildingTower.label}</span>,
    accessor: APARTMENTS_CONFIG.buildingTower.key,
    filterable: true,
    filterMethod: (filter, row) =>
      row[APARTMENTS_CONFIG.buildingTower.key]
        ? row[APARTMENTS_CONFIG.buildingTower.key]
          .toLowerCase()
          .includes(filter.value.toLowerCase())
        : ""
  },
  {
    Header: () => <span>{APARTMENTS_CONFIG.floor.label}</span>,
    accessor: APARTMENTS_CONFIG.floor.key,
    filterable: true,
    filterMethod: (filter, row) =>
      row[APARTMENTS_CONFIG.floor.key]
        ? row[APARTMENTS_CONFIG.floor.key]
          .toLowerCase()
          .includes(filter.value.toLowerCase())
        : ""
  },
  {
    Header: () => <span>{APARTMENTS_CONFIG.releaseDate.label}</span>,
    accessor: APARTMENTS_CONFIG.releaseDate.key,
    filterable: true,
    filterMethod: (filter, row) =>
      row[APARTMENTS_CONFIG.releaseDate.key]
        ? row[APARTMENTS_CONFIG.releaseDate.key]
          .toLowerCase()
          .includes(filter.value.toLowerCase())
        : ""
  },
  {
    Header: () => <span>{APARTMENTS_CONFIG.sector.label}</span>,
    accessor: APARTMENTS_CONFIG.sector.key,
    filterable: true,
    filterMethod: (filter, row) =>
      row[APARTMENTS_CONFIG.sector.key]
        ? row[APARTMENTS_CONFIG.sector.key]
          .toLowerCase()
          .includes(filter.value.toLowerCase())
        : ""
  },
  {
    Header: () => <span>{APARTMENTS_CONFIG.status.label}</span>,
    accessor: APARTMENTS_CONFIG.status.key,
    filterable: true,
    filterMethod: (filter, row) =>
      row[APARTMENTS_CONFIG.status.key]
        ? row[APARTMENTS_CONFIG.status.key]
          .toLowerCase()
          .includes(filter.value.toLowerCase())
        : ""
  },
  {
    Header: () => <span>{APARTMENTS_CONFIG.meter.label}</span>,
    accessor: APARTMENTS_CONFIG.meter.key,
    filterable: true,
    filterMethod: (filter, row) =>
      row[APARTMENTS_CONFIG.meter.key]
        ? row[APARTMENTS_CONFIG.meter.key]
          .toLowerCase()
          .includes(filter.value.toLowerCase())
        : ""
  },
  {
    Header: () => <span>Acciones</span>,
    filterable: false,
    sortable: false,
    Cell: ({ original }) => {
      const dispatch = useDispatch();
      const openEdit = () => {
        original.modal();
        dispatch(editApartment(original.id));
      };
      const openAssignMeter = () => {
        original.meterModal();
        dispatch(assignMeter(original.id));
      };
      const openAssignCustomer = () => {
        original.customerModal();
        dispatch(assignCustomer(original.id));
      };
      const openAssignContract = () => {
        original.contractModal();
        dispatch(assignContract(original.id));
      };
      const openServiceOff = () => {
        original.serviceOffModal();
        dispatch(editApartment(original.id));
      };
      const openServiceOn = () => {
        original.serviceOnModal();
        dispatch(editApartment(original.id));
      };

      return (
        <ColumnContainer>
          <RegularButton
            color="transparent"
            round
            justIcon
            tooltip="Asignar Cliente"
            onClick={openAssignCustomer}
            size="sm"
          >
            <AccountCircle style={style} />
          </RegularButton>
          <RegularButton
            color="transparent"
            round
            justIcon
            tooltip="Asignar Contrato"
            onClick={openAssignContract}
            size="sm"
          >
            <Assignment style={style} />
          </RegularButton>
          <RegularButton
            color="transparent"
            round
            justIcon
            tooltip="Asignar Medidor"
            onClick={openAssignMeter}
            size="sm"
          >
            <GasMeter style={style} onClick={openAssignMeter} />
          </RegularButton>
          <RegularButton
            color="transparent"
            round
            justIcon
            tooltip="Modificar Departamento"
            onClick={openEdit}
            size="sm"
          >
            <EditIcon style={style} onClick={openEdit} />
          </RegularButton>
          {original.rules.includes(PERMISSIONS.DISCONNECT_APARTMENT_SERVICE) && original.status == 'ACTIVO' &&
            <RegularButton
              color="transparent"
              round
              justIcon
              tooltip={APARTMENTS_PHRASE.modal.actions.serviceOff}
              onClick={openServiceOff}
              size="sm"
            >
              <PowerOffIcon style={style} />
            </RegularButton>
          }
          {original.rules.includes(PERMISSIONS.CONNECT_APARTMENT_SERVICE) && original.status == 'DESCONECTADO' &&
            <RegularButton
              color="transparent"
              round
              justIcon
              tooltip={APARTMENTS_PHRASE.modal.actions.serviceOn}
              onClick={openServiceOn}
              size="sm"
            >
              <PowerIcon style={style} />
            </RegularButton>
          }
        </ColumnContainer>
      );
    }
  }
];
